/* =================================================================
   br-article-body — keyboard access to wide article tables.
   (A11Y-B-19 / C-20.2)

   Merchant rich text can contain a table wider than the reading column.
   br-article-body.css scrolls it sideways inside its own box, but a scroll
   box with nothing focusable inside it cannot be reached from the keyboard
   in every browser, and it has no name when it can.

   For each table that ACTUALLY overflows, this wraps it once in a
   <div class="br-article-body__table-scroll"> and gives that wrapper
   tabindex="0", role="region" and an accessible name. The role goes on the
   wrapper, never on the <table>: a role on the table itself would replace
   its table semantics. A table that fits is left alone.

   Only top-level DATA tables count. Migrated articles carry one-cell layout
   tables (the "At a glance" boxes); those are never wrapped, never named and
   do not consume a number, so the first real table is "Table 1".

   Progressive enhancement only — without this script the CSS scroller is
   exactly what it was. Idempotent (a wrapped table is never wrapped twice,
   and a second execution of this file adds no second set of listeners) and
   re-checked on resize: a table that starts to overflow is wrapped, and one
   that stops is UNWRAPPED, so it renders exactly as it did before.
   ================================================================= */
(function () {
  'use strict';

  // The theme editor can execute this file more than once.
  if (window.brArticleTablesBound) return;
  window.brArticleTablesBound = true;

  var WRAP_CLASS = 'br-article-body__table-scroll';

  /* More than one row, or more than one cell in its only row. A one-cell
     table is a layout box, not data. */
  function isDataTable(table) {
    var rows = table.rows;
    return rows.length > 1 || (rows[0] && rows[0].cells.length > 1);
  }

  function labelFor(table, template, position) {
    var caption = table.querySelector('caption');
    var captionText = caption ? caption.textContent.replace(/\s+/g, ' ').trim() : '';
    if (captionText) return captionText;
    return template.replace('__n__', String(position));
  }

  function unwrap(wrapper, table) {
    wrapper.parentNode.insertBefore(table, wrapper);
    wrapper.parentNode.removeChild(wrapper);
  }

  function sync(prose) {
    var template = prose.getAttribute('data-table-scroll-label') || '';
    var tables = prose.querySelectorAll('table');
    var position = 0;

    Array.prototype.forEach.call(tables, function (table) {
      // A table nested inside another table scrolls with its parent.
      if (table.parentElement && table.parentElement.closest('table')) return;
      if (!isDataTable(table)) return;

      position += 1;

      var wrapper = table.parentElement;
      var wrapped = wrapper && wrapper.classList.contains(WRAP_CLASS);

      if (wrapped) {
        if (wrapper.scrollWidth > wrapper.clientWidth + 1) return;
        /* It fits again. Put it back as it was and fall through: the
           unwrapped measurement below decides, so a table sitting exactly on
           the edge cannot flip between the two states. */
        var hadFocus = document.activeElement === wrapper;
        unwrap(wrapper, table);
        if (table.scrollWidth <= table.clientWidth + 1) return;
        wrapped = false;
        wrapper = null;
        if (hadFocus) return; // never re-wrap under the reader's focus
      }

      if (table.scrollWidth <= table.clientWidth + 1) return;

      wrapper = document.createElement('div');
      wrapper.className = WRAP_CLASS;
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);

      // The wrapped table lays out as a real table box; trust that reading.
      if (wrapper.scrollWidth <= wrapper.clientWidth + 1) {
        unwrap(wrapper, table);
        return;
      }

      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', labelFor(table, template, position));
    });
  }

  function syncAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-article-prose]'), sync);
  }

  var frame = null;
  function onResize() {
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = null;
      syncAll(document);
    });
  }

  function init() {
    syncAll(document);
    window.addEventListener('resize', onResize);
    // Late images and web fonts can change a table's width after first paint.
    window.addEventListener('load', function () {
      syncAll(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    syncAll(event.target);
  });
})();
